import {
    RESET_MEDIA,
    GET_SWING_VIDEO_USER_SAS,
    GET_SWING_VIDEO_USER_SAS_SUCCESS,
    GET_SWING_VIDEO_USER_SAS_ERROR
} from '../constants/ActionTypes';

export const resetMedia = () => {
    return {
        type: RESET_MEDIA,
    };
};

export const getSwingVideoUserSas = (payload) => {
    return {
        type: GET_SWING_VIDEO_USER_SAS,
        payload: payload
    };
};

export const getSwingVideoUserSasSuccess = (userSasResponse) => {
    return {
        type: GET_SWING_VIDEO_USER_SAS_SUCCESS,
        payload: userSasResponse
    };
};

export const getSwingVideoUserSasError = (userSasResponse) => {
    return {
        type: GET_SWING_VIDEO_USER_SAS_ERROR,
        payload: userSasResponse
    };
};

